{
  "AUDIT_LOGS": {
    "HEADER": "Audit logok",
    "HEADER_BTN_TXT": "Audit logok hozzáadása",
    "LOADING": "Audit logok betöltése",
    "DESCRIPTION": "Az auditnaplók rögzítik a fiókban végzett tevékenységeket, így nyomon követheti és ellenőrizheti a fiókot, a csapatot vagy a szolgáltatásokat.",
    "LEARN_MORE": "Tudjon meg többet az auditnaplókról",
    "SEARCH_404": "Nincs megfelelő elem",
    "SIDEBAR_TXT": "<p><b>Auditnaplók</b> </p><p> Az auditnaplók a rendszer eseményeinek és műveleteinek nyomvonalai. </p>",
    "LIST": {
      "404": "Nincsen elérthető Auditnapló ebben a fiókban.",
      "TITLE": "Audit logok menedzselése",
      "DESC": "Az Auditnaplók a rendszer eseményeinek és műveleteinek nyomvonalai.",
      "TABLE_HEADER": {
        "ACTIVITY": "User",
        "TIME": "Action",
        "IP_ADDRESS": "IP cím"
      }
    },
    "API": {
      "SUCCESS_MESSAGE": "Auditnapló sikeresen lekérve",
      "ERROR_MESSAGE": "Nem sikerült csatlakozni a Woot szerverhez, kérjük próbáld később"
    },
    "DEFAULT_USER": "Rendszer",
    "AUTOMATION_RULE": {
      "ADD": "{agentName} új automatizálási szabályt hozott létre (#{id})",
      "EDIT": "{agentName} módosított egy automatizálási szabályt (#{id})",
      "DELETE": "{agentName} törölt egy automatizálási szabályt (#{id})"
    },
    "ACCOUNT_USER": {
      "ADD": "{agentName} meghívta {invitee} a fiókba, mint {role}",
      "EDIT": {
        "SELF": "{agentName} megváltoztatta az {attributes} -aikat {values} - ra",
        "OTHER": "{agentName} megváltoztatta {attributes}  {user}  {values} -ra",
        "DELETED": "{agentName} egy törölt felhasználó {attributes} értékét erre módosította: {values}"
      }
    },
    "INBOX": {
      "ADD": "{agentName} új postafiókot hozott létre (#{id})",
      "EDIT": "{agentName} módosított egy postafiókot (#{id})",
      "DELETE": "{agentName} törölt egy postafiókot (#{id})"
    },
    "WEBHOOK": {
      "ADD": "{agentName} új webhookot hozott létre (#{id})",
      "EDIT": "{agentName} módosított egy webhookot (#{id})",
      "DELETE": "{agentName} törölt egy webhookot (#{id})"
    },
    "USER_ACTION": {
      "SIGN_IN": "{agentName} aláírta",
      "SIGN_OUT": "{agentName} kijelentkezett"
    },
    "TEAM": {
      "ADD": "{agentName} új csapatot hozott létre (#{id})",
      "EDIT": "{agentName} módosított egy csapatot (#{id})",
      "DELETE": "{agentName} törölt egy csapatot (#{id})"
    },
    "MACRO": {
      "ADD": "{agentName} új makrót hozott létre (#{id})",
      "EDIT": "{agentName} módosított egy makrót (#{id})",
      "DELETE": "{agentName} törölt egy makrót (#{id})"
    },
    "INBOX_MEMBER": {
      "ADD": "{agentName} hozzáadta {user} felhasználót a postafiókhoz (#{inbox_id})",
      "REMOVE": "{agentName} eltávolította {user} felhasználót a postafiókból (#{inbox_id})"
    },
    "TEAM_MEMBER": {
      "ADD": "{agentName} hozzáadta {user} felhasználót a csapathoz (#{team_id})",
      "REMOVE": "{agentName} eltávolította {user} felhasználót a csapatból (#{team_id})"
    },
    "ACCOUNT": {
      "EDIT": "{agentName} módosította a fiók beállításait (#{id})"
    },
    "CONVERSATION": {
      "ADD": "{agentName} létrehozott egy beszélgetést (#{id})",
      "EDIT": "{agentName} frissített egy beszélgetést (#{id}): {changes}"
    },
    "CONTACT": {
      "ADD": "{agentName} létrehozott egy kapcsolatot (#{id})",
      "EDIT": "{agentName} frissített egy kapcsolatot (#{id}): {attributes}"
    }
  }
}
